import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"


const __default__ = {
  name: 'SelectFileOutsideGroup'
}

import { useMessage } from 'naive-ui'
import { useI18n } from 'vue-i18n'
import { useAppDialog } from '@/components/appDialog'
import Finder from '@/components/finder'
import type { FinderProps, FinderResponse } from '@/components/finder/types'
import ImportFileIntoGroup from './importFileIntoGroup.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    autoImport: { type: Boolean, default: true }
  },
  emits: ["back", "close", "confirm"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'back'): void
  (e: 'close'): void
  (e: 'confirm', context): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { autoImport: boolean }





const { t } = useI18n()
const message = useMessage()
const dialog = useAppDialog()

const finderProps: FinderProps = {
  action: 'selectFile',
  file: {
    // 轻维表 思维导图 白板 流程图 尚未对接相关产品，界面暂不满足需求，先屏蔽
    includes: ['weboffice', '.ksheet'],
    excludes: ['.kw', '.dbt', '.pof', '.pom'],
    fileLitmitNum: 1
  },
  featrues: {
    excludes: ['isLatestUseFolder', 'isShowSearch', '~']
  },
  okText: t('base.nextStep')
}

const confirm = (response: FinderResponse) => {
  const [file] = response.files
  if (!file) {
    message.error('No file found from VueFinder.')
  }
  const isLinkFile = file.ext === 'link'
  const fileId = isLinkFile ? Number(file.sourceData?.storeid) : file.id
  dialog.show({
    title: t('components.navigator.addOrUpdateNav.importFileTo'),
    component: ImportFileIntoGroup,
    componentProps: {
      file: {
        id: fileId,
        groupId: file.groupid,
        parentId: file.sourceData?.parentid
      },
      autoImport: props.autoImport
    },
    componentEvents: {
      confirm: async context => {
        emit('close')
        emit('confirm', context)
      }
    },
    footer: false
  })
}

const cancel = () => {
  emit('back')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Finder), _mergeProps(finderProps, {
    onConfirm: confirm,
    onCancel: cancel
  }), null, 16))
}
}

})